<div class="datepicker-input-container">
    <div class="datepicker-input-group">
        <input type="text" class="datepicker-input" [id]="fieldid" (click)="toggle()" readonly placeholder="Vælg dato" [(ngModel)]="date.formatted">
        <button *ngIf="date.formatted" class="btn-clear" (click)="clear($event)"><i class="fa fa-close"></i><span class="visuallyhidden">Ryd</span></button>
    </div>
    <div class="datepicker-input-icon" (click)="toggle()">
        <i class="fa fa-calendar"></i>
    </div>
</div>